export default "__VITE_ASSET__s1LZIagiOVJjueV7VK7LQg__"